import { ElMessage } from 'element-plus'

/** 重置message，防止重复点击重复弹出message消息提示 */
let messageInstance: any = null

const resetMessage: any = (options: any) => {
  if (messageInstance) {
    messageInstance.close()
  }
  // 手动关闭所有消息提示实例
  ElMessage.closeAll()
  messageInstance = ElMessage(options)
}

;['error', 'success', 'info', 'warning'].forEach((type) => {
  resetMessage[type] = (options: any) => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
    }
    options.type = type
    return resetMessage(options)
  }
})

export default resetMessage
